(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["../ngmodules/people-platform/components/employee-satisfaction/chart-tooltip.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<style> .es__chart-tooltip {\n    padding: 5px 10px 5px;\n}\n\n.es__chart-tooltip .es__ct__title {\n    border-bottom: 1px solid #E6E6E6;\n    padding-bottom: 10px;\n}\n\n.es__chart-tooltip .es__ct__title span:first-child {\n  color: #3B3B3B;\n  font-size: 22px;\n  line-height: 24px;\n  font-weight: 600;\n}\n\n.es__chart-tooltip .es__ct__title span:last-child {\n  color: rgba(52,52,52,0.85);\n  font-size: 12px;\n  line-height: 13px;\n  font-weight: 600;\n}\n\n.es__chart-tooltip .es__ct__content {\n    gap: 10px;\n    padding: 10px 0 5px;\n}\n\n.es__chart-tooltip .es__ct__category > span {\n    width: 50%;\n}\n\n.es__chart-tooltip .es__ct__category > span:first-child {\n  color: #6D7278;\n  font-size: 12px;\n  line-height: 13px;\n}\n\n.es__chart-tooltip .es__ct__category > span:last-child {\n    padding-left: 3px;\n}\n\n.es__chart-tooltip .es__ct__category .es__ct__percent {\n    font-size: 14px;\n    line-height: 16px;\n    font-weight: 600;\n    color: #959595;\n}\n\n.es__chart-tooltip .es__ct__category.es__ct__category-red .es__ct__percent {\n    color: #B8192F;\n}\n\n.es__chart-tooltip .es__ct__category.es__ct__category-green .es__ct__percent {\n    color: #3B8E2D;\n}\n\n.es__chart-tooltip .es__ct__category.es__ct__category-red .es__ct__bar > div {\n    background: #B8192F;\n}\n\n.es__chart-tooltip .es__ct__category.es__ct__category-green .es__ct__bar > div {\n    background: #3B8E2D;\n}\n\n.es__chart-tooltip .es__ct__category .es__ct__bar {\n    border-radius: 4px;\n    width: 65px;\n    height: 15px;\n    background: #efefef;\n    flex: 0 0 auto;\n    overflow: hidden;\n}\n\n.es__chart-tooltip .es__ct__category .es__ct__bar .es__ct__bar-inner {\n    width: 0%;\n    height: 100%;\n}\n\n.es__chart-tooltip .es__ct__category .es__ct__percent .es__ct__arrow-up,\n.es__chart-tooltip .es__ct__category .es__ct__percent .es__ct__arrow-down {\n    width: 7px;\n    height: 10px;\n    margin-right: 2px;\n}\n\n.es__chart-tooltip .es__ct__category .es__ct__percent .es__ct__arrow-up {\n    background-image: url('../images/satisfaction/up_mini-dark.svg');\n}\n\n.es__chart-tooltip .es__ct__category .es__ct__percent .es__ct__arrow-down {\n    background-image: url('../images/satisfaction/down_mini-dark.svg');\n} </style> <div class=\"es__chart-tooltip\"> ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "groupValues");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("groupValue", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += " <div class=\"es__ct__title d-flex align-items-center justify-content-between\"> <span class=\"mr-3\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"value"), env.opts.autoescape);
output += "%</span> <span class=\"d-flex align-items-center\"> <span class=\"user-tag-icon user-tag-icon__md mr-2 ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"map")),"icon"), env.opts.autoescape);
output += "\"></span> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"map")),"title"), env.opts.autoescape);
output += " </span> </div> <div class=\"es__ct__content d-flex flex-column\"> ";
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.memberLookup((t_4),"map")),"categories");
if(t_7) {t_7 = runtime.fromIterator(t_7);
var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("category", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += " <div class=\"es__ct__category ";
if(runtime.memberLookup((t_8),"value") > 0) {
output += " es__ct__category-green ";
;
}
else {
if(runtime.memberLookup((t_8),"value") < 0) {
output += " es__ct__category-red ";
;
}
;
}
output += " d-flex align-items-center justify-content-between\"> <span>";
output += runtime.suppressValue(runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "</span> <span class=\"d-flex align-items-center justify-content-between\"> <div class=\"es__ct__bar mr-2\"> ";
if(runtime.memberLookup((t_8),"value") > 0) {
output += " <div class=\"es__ct__bar-inner\" style=\"width: ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"value"), env.opts.autoescape);
output += "%;\"></div> ";
;
}
else {
output += " <div class=\"es__ct__bar-inner\" style=\"width: ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"value") * -1, env.opts.autoescape);
output += "%;\"></div> ";
;
}
output += " </div> <span class=\"es__ct__percent d-flex align-items-center\"> ";
if(runtime.memberLookup((t_8),"value") > 0) {
output += " <span class=\"es__ct__arrow-up\"></span> ";
;
}
else {
if(runtime.memberLookup((t_8),"value") < 0) {
output += " <span class=\"es__ct__arrow-down\"></span> ";
;
}
;
}
output += " ";
if(runtime.memberLookup((t_8),"value") > 0) {
output += " ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"value"), env.opts.autoescape);
output += "% ";
;
}
else {
output += " ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"value") * -1, env.opts.autoescape);
output += "% ";
;
}
output += " </span> </span> </div> ";
;
}
}
frame = frame.pop();
output += " </div> ";
;
}
}
frame = frame.pop();
output += " </div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
